export default __webpack_public_path__ + "static/endurance-white-58f91eeed127a9227ce65da1f17dacd0.png";